import { Money } from '@acorns/web-utils'

import { BillingFrequency, TierPrice } from 'generated/types'

export const formatTierPrice = (input: {
  tierPrice: Pick<TierPrice, 'amountV2' | 'billingFrequency'>
}) => {
  let dailyPrice
  let monthlyPrice

  const billingFrequency = input.tierPrice.billingFrequency

  if (billingFrequency === BillingFrequency.Monthly) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    monthlyPrice = new Money({
      payload: input.tierPrice.amountV2 as any,
    }).toCurrency({
      withDecimal: false,
    })
    const dailyPayload = {
      ...input.tierPrice.amountV2,
      value: input.tierPrice.amountV2.value / 30,
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dailyPrice = new Money({ payload: dailyPayload as any }).toCurrency({
      withDecimal: true,
    })
  }

  if (!dailyPrice || !monthlyPrice) {
    throw new Error(`Billing frequency ${billingFrequency} is unsupported`)
  }

  return {
    daily: dailyPrice,
    monthly: monthlyPrice,
  }
}
